import {PolIcon} from "components/PolIcon/policon";
import React from 'react';
import Draggable from "react-draggable";
import {Link} from "react-router-dom";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import { resolveUrl } from "v4/features/front/navigation/utils/route.utils";
import {usePolTranslation} from "v4/hooks/usePolTranslation";

export default function ProspectMapDraggable({selectedProspect, removeSelectedProspect, offsetParent, bounds}) {
    const {t} = usePolTranslation();
    const {getRouteByNativeIdentifier} = useNavigation();

    return (
        <Draggable handle=".prospects-listing-maps__prospect__header"
                   offsetParent={offsetParent}
                   bounds={bounds}>
            <div className="prospects-listing-maps__prospect">
                <div className="prospects-listing-maps__prospect__header">
                    <PolIcon
                        icon={getProspectValue(selectedProspect, 'isBusiness') ? "business" : 'store-alt'}/>
                    <span>{getProspectValue(selectedProspect, 'fullname')}</span>
                    <PolIcon className="prospects-listing-maps__prospect__header__close" icon="close"
                             onClick={removeSelectedProspect}/>
                </div>
                <div className="prospects-listing-maps__prospect__infos">
                    <p>
                        {t('type')} : <span>{t(getProspectValue(selectedProspect, 'prospectType'))}</span>
                    </p>
                    <p>
                        {t('email')} :
                        <span>{
                            getProspectValue(selectedProspect, 'mail')
                                ? (
                                    <a href={`mailto:${getProspectValue(selectedProspect, 'mail')}`}>
                                        {getProspectValue(selectedProspect, 'mail')}
                                    </a>
                                ) : t('undefined')}
                        </span>
                    </p>
                </div>
                {getProspectValue(selectedProspect, 'address') && (
                    <div className="prospects-listing-maps__prospect__address">
                        <p>
                            <span>
                                <b>
                                    {getProspectValue(selectedProspect, 'address')?.address}
                                    <br/>
                                    {getProspectValue(selectedProspect, 'address')?.postalCode} {getProspectValue(selectedProspect, 'address')?.city}
                                </b>
                            </span>
                        </p>
                    </div>
                )}
                <div className="prospects-listing-maps__prospect__phone">
                    {getProspectValue(selectedProspect, 'phone') && (
                        <>
                            <PolIcon icon="phone"/>
                            <p>
                                <span>{getProspectValue(selectedProspect, 'phone')}</span>
                            </p>
                        </>
                    )}
                    <Link to={`/${resolveUrl(getRouteByNativeIdentifier('detail_open_tasks').url, {prospect: selectedProspect?.metadata?.id})}`}
                          className="prospects-listing-maps__prospect__go" title={t('see-prospect')}>
                        <PolIcon icon="arrow-right"/>
                    </Link>
                </div>
            </div>
        </Draggable>
    )
}

function getProspectValue(prospect, desiredKey) {
    if (!prospect) return null;

    const {metadata, results} = prospect;

    if (desiredKey in (metadata ?? {})) return metadata?.[desiredKey];

    const fields = Object.values(results).map(({properties}) => properties).flat();
    return fields.find(({key}) => key === desiredKey)?.value ?? null;
}
